;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/CarouselPicturePane',["jquery", "eventManager", 'loglevel', "score_bootstrap/Base/PictureAsBackground"], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require('loglevel'), require("score_bootstrap/Base/PictureAsBackground")) :
    console && console.error('CarouselPane does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, log, PictureAsBackground) {

    function CarouselPicturePane(scope, selectActionMessages) {
        var self = this;

        Object.defineProperty(this, "$scope", { enumerable: !0, value: $(scope) });

        //#region select on mesage performer
        if (selectActionMessages.length) {
            selectActionMessages.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.makeActive, self);
            });
        }
        //#endregion

        PictureAsBackground.call(this, scope, '> .score-carousel-pic-pane-body > picture', '> .score-editField-group > .pic-thumb > picture');
    }

    CarouselPicturePane.prototype = Object.create(PictureAsBackground.prototype);

    CarouselPicturePane.prototype.makeActive = function () {
        var carousel = this.$scope.closest('.carousel');

        if (!carousel) {
            log.error("Cannot detect carousel element. Carousel panel selection canceled.");
            return !1;
        }

        var index = carousel.find('.carousel-inner > .item').index(this.$scope);
        carousel.carousel(index);
    };

    CarouselPicturePane.init = function init(args) {
        return new CarouselPicturePane(args.scope, args.SelectActionMessages || []);
    };

    return CarouselPicturePane;
}));
